import { render } from "./Accueil.vue?vue&type=template&id=56e0feed&scoped=true"
import script from "./Accueil.vue?vue&type=script&lang=js"
export * from "./Accueil.vue?vue&type=script&lang=js"

import "./Accueil.vue?vue&type=style&index=0&id=56e0feed&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Alexa\\OneDrive\\Bureau\\infolio\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e0feed"]])

export default __exports__